import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import config from '../config'

Vue.use(Vuex)

const initialState = {
  userLikesMap: {}
}

const getters = {
  userLikes: state => idItem => state.userLikesMap[idItem] || []
}

const mutations = {
  userLikes: (state, { userLikes, idItem }) => {
    state.userLikesMap[idItem] = userLikes
  }
}

const actions = {
  async fetchUserLikes({ commit }, { idItem, itemType }) {
    let promise
    if (itemType === 'Post') {
      promise = axios.get(`${config.getRootApi()}/posts/${idItem}/likes`)
    } else if (itemType === 'Comment') {
      promise = axios.get(`${config.getRootApi()}/comments/${idItem}/likes`)
    } else {
      console.error(`Unknown item type ${itemType}`)
      return
    }
    const res = await promise
    if (res.status === 200) {
      commit('userLikes', { userLikes: res.data, idItem: idItem })
    }
  }
}

export default {
  state: initialState,
  getters,
  mutations,
  actions
}
